import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

/** MyMine Version2.1 新規作成
 * MyMCheckBox Component
 * @param {any} param0
 * @returns
 */
export const MyMCheckBox = ({ label, labelPlacement, ...other }) => {
  return (
    <FormControlLabel control={<Checkbox {...other} />} label={label} labelPlacement={labelPlacement ?? 'end'} />
  )
}